import { Card } from "react-rainbow-components";
import styled from "styled-components";
import { Container } from "../../components/common/Container";
import breakpoint from "../../assets/breakpoints";
export const Containers = styled(Container)`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const GroupCard = styled.div`
  display: flex;
  justify-content: space-between;
  @media only screen and (max-width: 600px) {
    flex-direction: column;
  }
`;
export const SelectContainer = styled.div`
  margin: 0.5rem;
`;
export const ContainerCard = styled.div`
  flex: 1;
  display: flex;
`;
export const MyCard = styled(Card)`
  display: flex;
  flex: 1;
  margin: 0.5rem;
  max-width: calc(100vw - 78px - 1rem);
  @media only screen and ${breakpoint.device.sm} {
    max-width: none;
  }
  &.group-card {
    align-items: center;
    justify-content: center;
    padding: 1rem;
    @media only screen and (max-width: 600px) {
      padding: 0.5rem;
    }
    cursor: pointer;

    & > svg {
      @media only screen and (max-width: 600px) {
        display: none;
      }
    }
    & > div {
      margin-left: 1rem;
      flex: 1;
      @media only screen and (max-width: 768px) {
        display: none;
      }
      @media only screen and (max-width: 600px) {
        margin-left: 0;
        display: block;
      }

      & > h6 {
        @media only screen and (max-width: 600px) {
          margin: 0;
        }
      }
      & > p {
        @media only screen and (max-width: 600px) {
          display: none;
        }
        margin: 0;
        font-size: 0.75rem;
        &.right {
          text-align: right;
        }
      }
    }
  }
  &.content {
    overflow: scroll;
  }
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* for Internet Explorer, Edge */
  scrollbar-width: none; /* for Firefox */
  overflow-y: hidden;
  overflow-x: hidden;
`;
